<template>
	<div v-loading="loading" class="base_scroll_page">
		<div class="b_scroller">
			<!-- 表格 -->
			<div class="base_table">
				<el-table
					:data="tableData"
					style="width: 100%"
				>
					<el-table-column
						width="200"
						prop="time"
						label="时间"
					>
					</el-table-column>
					<el-table-column
						prop="detail"
						label="详细信息"
					>
					</el-table-column>
					<el-table-column
						label="操作"
						width="200"
					>
						<template slot-scope="scope">
							<el-button
								style="color: #f00;"
								@click="handleDeleteClick(scope.row)"
							>删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
		</div>
		
		<!-- 删除弹出框 -->
		<Popup
			v-model="delete_display"
			title="提示"
			@confirmClick="handleDeletePopupConfirmClick"
		>
			<div style="padding: 15px;">
				<p style="color: #5f6468;line-height: 24px;">您确认要删除该异常吗？</p>
			</div>
		</Popup>
		<!-- 删除弹出框 end -->
	</div>
</template>

<script>
	import Api from '../../../../../api/index.js'
	
	export default {
		mounted () {
			this.getList();
		},
		data () {
			return {
				loading: false,
				
				tableData: [],
				
				delete_display: false,
				delete_time: ''
			}
		},
		methods: {
			/************************ @Function *******************************/
			// 点击删除
			handleDeleteClick (obj) {
				this.delete_time = obj.time;
				this.delete_display = true;
			},
			// 点击删除弹框确定按钮
			handleDeletePopupConfirmClick () {
				const that = this;
				that.loading = true;
				var requestData = {
					time: that.delete_time
				};
				Api.deleteLogMallUnusual(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.delete_display = false;
						that.$message.success(res.data.message);
						that.getList();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			
			/************************ @Function *******************************/
			// 获取数据
			getList () {
				const that = this;
				that.loading = true;
				var requestData = {};
				Api.findLogMallUnusual(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.tableData = [];
						for (var i = 0;i < res.data.data.length;i++) {
							var _o = res.data.data[i];
							that.tableData.push({
								id: _o.id,
								time: _o.time || '',
								detail: _o.info || ''
							});
						}
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		}
	}
</script>

<style scoped>
</style>
